import { formatNotificationTime } from '../../../assets/services/notifications';
import BottomSheet from '../../shared/BottomSheet/BottomSheet';
import { getNotificationPresentation } from './notificationPresentation';
import './NotificationDetailSheet.css';

function DetailRow({ label, value }) {
  if (!value) return null;

  return (
    <div className="notification-detail-sheet__row">
      <dt className="notification-detail-sheet__term">{label}</dt>
      <dd className="notification-detail-sheet__value">{value}</dd>
    </div>
  );
}

function NotificationDetailSheet({
  language,
  notification,
  notificationsCopy,
  onClose,
}) {
  const { Icon, variant } = getNotificationPresentation(notification.type);
  const location = [
    notification.loginMeta?.city,
    notification.loginMeta?.countryTitle,
  ].filter(Boolean).join(', ');

  return (
    <BottomSheet
      className="notification-detail-sheet"
      panelClassName="notification-detail-sheet__panel"
      titleId="notification-detail-sheet-title"
      onClose={onClose}
    >
      <div className="notification-detail-sheet__hero">
        <span
          className={`notification-detail-sheet__icon notification-detail-sheet__icon--${variant}`}
          aria-hidden="true"
        >
          <Icon className="notification-detail-sheet__icon-svg" />
        </span>
        <time className="notification-detail-sheet__time" dateTime={notification.createdAt}>
          {formatNotificationTime(notification.createdAt, language)}
        </time>
        <h2 id="notification-detail-sheet-title" className="notification-detail-sheet__title">
          {notification.title}
        </h2>
        <p className="notification-detail-sheet__body">{notification.body}</p>
      </div>

      {notification.loginMeta && (
        <dl className="notification-detail-sheet__details">
          <DetailRow label={notificationsCopy.locationLabel} value={location} />
          <DetailRow label={notificationsCopy.ipAddressLabel} value={notification.loginMeta.ip} />
          <DetailRow
            label={notificationsCopy.deviceLabel}
            value={notification.loginMeta.userAgent}
          />
        </dl>
      )}
    </BottomSheet>
  );
}

export default NotificationDetailSheet;
